export const SITE_URL = 'https://www.andreavillalobos.com'
export const PERSON_ID = `${SITE_URL}/#person`
export const SITE_ID = `${SITE_URL}/#website`
export const PROFESSIONAL_PHOTO_URL = `${SITE_URL}/images/person-andrea-smiling.png`

export interface SchemaObject {
  '@context': 'https://schema.org'
  '@type': string
  [key: string]: unknown
}

const personSchema: SchemaObject = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': PERSON_ID,
  name: 'Andrea Villalobos',
  url: SITE_URL,
  image: PROFESSIONAL_PHOTO_URL,
  email: 'info@andreavillalobos.com',
  jobTitle: 'GLP-1 Accountability & Longevity Guide',
  description: 'Andrea Villalobos provides non-medical, remote GLP-1 accountability and lifestyle support alongside licensed clinical care.',
}

const websiteSchema: SchemaObject = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': SITE_ID,
  name: 'Andrea Villalobos',
  url: SITE_URL,
  publisher: { '@id': PERSON_ID },
}

const serviceSchema: SchemaObject = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Remote GLP-1 Accountability Support',
  provider: { '@id': PERSON_ID },
  description: 'Non-medical accountability, routine, and lifestyle support for people using GLP-1 medication alongside licensed clinical care.',
  serviceType: 'Accountability and lifestyle support',
}

export function getStructuredData(pathname: string): SchemaObject[] {
  if (pathname === '/') {
    return [personSchema, websiteSchema]
  }

  if (pathname === '/main') {
    return [personSchema, websiteSchema, serviceSchema]
  }

  return []
}

export function serializeSchema(schema: SchemaObject): string {
  return JSON.stringify(schema)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
}
